
import { React, Button, useState , useParams, Modal} from "../utils/thirdpartyComponents";
import {
  WhatsappShareButton,
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  LinkedinShareButton,
  InstapaperShareButton,
  WhatsappIcon,
  EmailIcon,
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  InstapaperIcon,
  LinkedinIcon,
} from 'react-share';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported

interface ShareModalProps {
  show: boolean;
  handleClose: () => void;
  referralCode: string;
  referralCodeDescription ? : string;
  titleText? : string;
  paraText? : string;
  type?:string;
}

const ShareModal: React.FC<ShareModalProps> = ({ show, handleClose, referralCode, referralCodeDescription,titleText,paraText,type }) => {
  const params = useParams();
  const shareUrl =  `${process.env.REACT_APP_SITE_URL || ""}${params.carwashname}/signup`;
  //const shareUrl = carwashUrl+`/signup?code=${referralCode}`;
  const referralMessage = `${referralCodeDescription || ''} Go to ${shareUrl} and sign up using my ${type=='FC'? 'Family Code: ' : 'code: '}  ${referralCode}. Don't forget to subscribe when you sign up.`
  const handleSmsShare = () => {
    window.location.href = `sms:?&body=${referralMessage}`;
  };

  return (
    <Modal show={show} onHide={handleClose} className='refer-modal' centered>
      <Modal.Header closeButton>
        <Modal.Title>{titleText}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='text-center mb-4'>{paraText}</p>
        <div className="icon-holder d-flex justify-content-center">
          <WhatsappShareButton url={shareUrl} title={`${referralMessage}`}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
          <EmailShareButton url={shareUrl} subject="Join me on this amazing app!" body={`${referralMessage}`}>
            <EmailIcon size={32} round />
          </EmailShareButton>
          <FacebookShareButton url={shareUrl} quote={`${referralMessage}`}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <TwitterShareButton url={shareUrl} title={`${referralMessage}`}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>
          <TelegramShareButton url={shareUrl} title={`${referralMessage}`}>
            <TelegramIcon size={32} round />
          </TelegramShareButton>
          <InstapaperShareButton url={shareUrl} title={`${referralMessage}`}>
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
          <LinkedinShareButton url={shareUrl} title={`${referralMessage}`}>
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
          <Button variant="info" onClick={handleSmsShare} className='d-flex align-items-center justify-content-center'>
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="17.263" height="17.24" viewBox="0 0 17.263 17.24">
  <g id="_6358088_bubble_chat_conversation_inbox_message_icon" data-name="6358088_bubble_chat_conversation_inbox_message_icon" transform="translate(-2 -2)">
    <path id="Path_622" data-name="Path 622" d="M15.615,28.436a.615.615,0,1,1,0-1.231,7.386,7.386,0,0,0,3.958-1.145.615.615,0,1,1,.659,1.034A8.555,8.555,0,0,1,15.615,28.436Z" transform="translate(-4.999 -9.202)" fill="#fff"/>
    <path id="Path_623" data-name="Path 623" d="M26.615,20.5a.615.615,0,0,1-.523-.942,7.386,7.386,0,0,0,1.139-3.939.615.615,0,1,1,1.231,0,8.617,8.617,0,0,1-1.323,4.592A.616.616,0,0,1,26.615,20.5Z" transform="translate(-9.227 -4.999)" fill="#fff"/>
    <path id="Path_624" data-name="Path 624" d="M10.617,19.234a8.617,8.617,0,1,1,8.617-8.617.615.615,0,0,1-1.231,0A7.386,7.386,0,1,0,10.617,18a.615.615,0,1,1,0,1.231Z" fill="#fff"/>
    <path id="Path_625" data-name="Path 625" d="M26.307,28.461a.769.769,0,0,1-.2-.031L22.417,27.2a.617.617,0,1,1,.394-1.169L26.5,27.261a.612.612,0,0,1-.2,1.2Z" transform="translate(-7.689 -9.227)" fill="#fff"/>
    <path id="Path_626" data-name="Path 626" d="M27.845,26.923a.615.615,0,0,1-.585-.419L26.03,22.811a.617.617,0,0,1,1.169-.394L28.43,26.11a.615.615,0,0,1-.388.812A.77.77,0,0,1,27.845,26.923Z" transform="translate(-9.227 -7.689)" fill="#fff"/>
    <path id="Path_627" data-name="Path 627" d="M15.231,16.462a1.231,1.231,0,1,1,1.231-1.231A1.231,1.231,0,0,1,15.231,16.462Zm0-1.231Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Z" transform="translate(-4.614 -4.614)" fill="#fff"/>
    <path id="Path_628" data-name="Path 628" d="M22.231,16.462a1.231,1.231,0,1,1,1.231-1.231A1.231,1.231,0,0,1,22.231,16.462Zm0-1.231Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Z" transform="translate(-7.306 -4.614)" fill="#fff"/>
    <path id="Path_629" data-name="Path 629" d="M8.231,16.462a1.231,1.231,0,1,1,1.231-1.231A1.231,1.231,0,0,1,8.231,16.462Zm0-1.231Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Z" transform="translate(-1.923 -4.614)" fill="#fff"/>
  </g>
</svg> */}


            <svg fill="none" height="24" strokeWidth="1.5" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 12L17 12" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 8L13 8" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 20.2895V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V15C21 16.1046 20.1046 17 19 17H7.96125C7.35368 17 6.77906 17.2762 6.39951 17.7506L4.06852 20.6643C3.71421 21.1072 3 20.8567 3 20.2895Z" stroke="#fff" strokeWidth="1.5" />
            </svg>


          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
